import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { AiOutlineClose } from "react-icons/ai";

const SeoKeywords = ({
  element,
  form,
  setForm,
  options: { title = "کلمات کلیدی سئو", key = "seoKeyword", nested = "seo" },
}) => {
  const [word, setWord] = useState("");
  useEffect(() => {
    if (nested) {
      if (form[nested] && form[nested][key]) {
        if (Array.isArray(form[nested][key])) {
        } else {
          setForm({
            ...form,
            [nested]: {
              ...form[nested],
              [key]: [],
            },
          });
        }
      } else {
        setForm({ ...form, [nested]: { [key]: [] } });
      }
    } else {
      if (form[key]) {
        if (Array.isArray(form[key])) {
        } else {
          setForm({
            ...form,
            [key]: [],
          });
        }
      } else {
        setForm({ ...form, [key]: [] });
      }
    }
  }, []);

  const addWordHandler = () => {
    if (nested) {
      if (!form[nested][key].includes(word)) {
        setForm({
          ...form,
          [nested]: {
            ...form[key],
            [key]: [...form[nested][key], word].filter(Boolean),
          },
        });
        setWord("");
      } else {
        toast.error(" قبلا وارد شده است");
      }
    } else {
      if (!form[key].includes(word)) {
        setForm({
          ...form,
          [key]: [...form[key], word].filter(Boolean),
        });
        setWord("");
      } else {
        toast.error(" قبلا وارد شده است");
      }
    }
  };
  const deleteWord = wo => {
    if (nested) {
      setForm({
        ...form,
        [nested]: {
          ...form[nested],
          [key]: form[nested][key]
            .map(ele => {
              if (ele != wo) {
                return ele;
              }
            })
            .filter(Boolean),
        },
      });
    } else {
      setForm({
        ...form,
        [key]: form[key]
          .map(ele => {
            if (ele != wo) {
              return ele;
            }
          })
          .filter(Boolean),
      });
    }
  };
  const renderkeys = () => {
    if (form[nested]) {
      if (Array.isArray(form[nested][key])) {
        if (form[nested][key].length != 0) {
          return form[nested][key].map(item => {
            return (
              <button
                key={item}
                className="btn btn-outline-dark m-2"
                onClick={() => {
                  deleteWord(item);
                }}
              >
                <span>{item}</span>
                <span style={{ marginRight: "10px" }}>
                  <AiOutlineClose />
                </span>
              </button>
            );
          });
        } else {
          return (
            <h6 style={{ textAlign: "center", fontWeight: "400" }}>
              موردی یافت نشد
            </h6>
          );
        }
      } else {
        return (
          <h6 style={{ textAlign: "center", fontWeight: "400" }}>
            موردی یافت نشد
          </h6>
        );
      }
    } else {
      if (Array.isArray(form[key])) {
        if (form[key].length != 0) {
          return form[key].map(item => {
            return (
              <button
                className="btn btn-outline-dark m-2"
                onClick={() => {
                  deleteWord(item);
                }}
              >
                <span>{item}</span>
                <span style={{ marginRight: "10px" }}>
                  <AiOutlineClose />
                </span>
              </button>
            );
          });
        } else {
          return (
            <h6 style={{ textAlign: "center", fontWeight: "400" }}>
              موردی یافت نشد
            </h6>
          );
        }
      } else {
        return (
          <h6 style={{ textAlign: "center", fontWeight: "400" }}>
            موردی یافت نشد
          </h6>
        );
      }
    }
  };
  return (
    <div className="col-12 my-4">
      <div>
        <label style={{ fontWeight: "400" }}>{title}</label>
        <div className="d-flex mb-2">
          <input
            className="form-control"
            placeholder={`${title} را وارد کنید`}
            onChange={({ target: { value } }) => {
              setWord(value);
            }}
            value={word}
            onKeyDown={e => {
              if (e.key == "Enter") {
                addWordHandler();
              }
            }}
          />
          <button className="btn btn-primary mr-2" onClick={addWordHandler}>
            ثبت
          </button>
        </div>
      </div>
      <div className="border rounded p-2">{renderkeys()}</div>
    </div>
  );
};

export default SeoKeywords;
